/**
 * Docs are served at two locations:
 *   - docs.writerslogic.com/<page>   (canonical, clean URLs)
 *   - writerslogic.com/docs/<page>   (legacy; 301-redirected to the subdomain
 *     at the edge via public/_redirects)
 *
 * The SPA is the same bundle on both hosts. On the docs subdomain the docs
 * routes are mounted at the root, so every internal docs link and route path
 * must be rewritten to drop the `/docs` prefix. Client-side <Link> navigation
 * never hits the edge redirects, so this rewrite has to happen in the app.
 */
export const IS_DOCS_HOST =
  typeof window !== "undefined" && window.location.hostname.startsWith("docs.");

/**
 * Rewrite a canonical `/docs[/...]` path for the current host.
 * On the docs subdomain `/docs/cli` -> `/cli` and `/docs` -> `/`.
 * On the main site it is returned unchanged.
 */
export function docsTo(path: string): string {
  if (!IS_DOCS_HOST) return path;
  const stripped = path.replace(/^\/docs/, "");
  return stripped === "" ? "/" : stripped;
}

/** Absolute origin for docs canonical URLs on the current host. */
export const DOCS_CANONICAL_ORIGIN = IS_DOCS_HOST
  ? "https://docs.writerslogic.com"
  : "https://writerslogic.com";
